import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";

var UserInfo =
/*#__PURE__*/
function (_Vue) {
  _inherits(UserInfo, _Vue);

  function UserInfo() {
    _classCallCheck(this, UserInfo);

    return _possibleConstructorReturn(this, _getPrototypeOf(UserInfo).apply(this, arguments));
  }

  _createClass(UserInfo, [{
    key: "mounted",
    value: function mounted() {}
  }]);

  return UserInfo;
}(Vue);

tslib_1.__decorate([Prop({
  default: ""
})], UserInfo.prototype, "userPic", void 0);

tslib_1.__decorate([Prop({
  default: ''
})], UserInfo.prototype, "userName", void 0);

tslib_1.__decorate([Prop({
  default: true
})], UserInfo.prototype, "spec", void 0);

tslib_1.__decorate([Prop({
  default: ''
})], UserInfo.prototype, "gender", void 0);

UserInfo = tslib_1.__decorate([Component({
  components: {}
})], UserInfo);
export default UserInfo;